var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-visualization-item-emort-text howahowaup-infinite"},[_c('span',{staticClass:"fz16"},[_vm._v(_vm._s(_vm.targetEmoji))])])}
var staticRenderFns = []

export { render, staticRenderFns }